import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const stepDelays = ['delay-2', 'delay-3', 'delay-4'];

export default function ExplanationSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="cause" className="bg-white py-16 md:py-24">
      <div ref={ref} className={`w-full px-4 md:px-8 max-w-5xl mx-auto scroll-reveal ${isVisible ? 'visible' : ''}`}>
        <h2 className="font-serif text-xl md:text-3xl font-bold text-clinic-dark text-center mb-4 scroll-reveal-item delay-1">
          自律神経が乱れる原因は、
          <br />
          <span className="text-clinic-terracotta">「脳の疲れ」</span>
          にあります
        </h2>
        <p className="text-clinic-gray text-sm md:text-base text-center mb-10 md:mb-14 max-w-2xl mx-auto leading-relaxed scroll-reveal-item delay-1">
          私たちの脳の中には、心を穏やかにし、体の調子を整えてくれる「安心ホルモン（セロトニン）」という成分があります。
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-10 md:mb-14">
          <div className={`bg-clinic-cream-dark rounded-xl p-5 md:p-6 text-center scroll-reveal-item ${stepDelays[0]}`}>
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-clinic-terracotta text-white font-bold text-lg md:text-xl mx-auto mb-3">
              1
            </div>
            <h3 className="font-bold text-clinic-dark text-sm md:text-base mb-2">ストレスが溜まる</h3>
            <p className="text-clinic-gray text-xs md:text-sm leading-relaxed">
              毎日の家事や育児、お仕事のストレスが溜まると、この「安心ホルモン」が少なくなってしまいます。
            </p>
          </div>
          <div className={`bg-clinic-cream-dark rounded-xl p-5 md:p-6 text-center scroll-reveal-item ${stepDelays[1]}`}>
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-clinic-terracotta text-white font-bold text-lg md:text-xl mx-auto mb-3">
              2
            </div>
            <h3 className="font-bold text-clinic-dark text-sm md:text-base mb-2">ブレーキが効かない</h3>
            <p className="text-clinic-gray text-xs md:text-sm leading-relaxed">
              すると、車でいう「ブレーキ」が効かなくなり、体は常に戦っているような「緊張モード」になってしまうのです。
            </p>
          </div>
          <div className={`bg-clinic-cream-dark rounded-xl p-5 md:p-6 text-center scroll-reveal-item ${stepDelays[2]}`}>
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-clinic-terracotta text-white font-bold text-lg md:text-xl mx-auto mb-3">
              3
            </div>
            <h3 className="font-bold text-clinic-dark text-sm md:text-base mb-2">不調の正体</h3>
            <p className="text-clinic-gray text-xs md:text-sm leading-relaxed">
              これが、あなたが感じているめまい・頭痛・不眠の正体です。脳を休ませることで改善できます。
            </p>
          </div>
        </div>

        <div className="bg-clinic-green-dark rounded-xl p-6 md:p-8 text-center scroll-reveal-item delay-5">
          <p className="text-white text-sm md:text-base font-medium leading-relaxed">
            セロトニン活性療法は、この「安心ホルモン」を脳からたっぷり出すように優しく体に触れるだけの特別な方法です。
          </p>
        </div>
      </div>
    </section>
  );
}